module.exports = __webpack_public_path__ + "img/launch_thumbnail.8afad777.jpg";